import React from "react";
import "./Login.css";
import IsbcLogIn from "../../assests/IsbcLogIn.webp";
import Twilio from "../TwilioLogin/TwilioLogin";
import GoogleLoginBtn from "../SocialLogins/Google";
import { Link } from "react-router-dom";

function Login() {
  return (
    <div className="Login-bg-main">
      <div className="Log-Twoparts">
        <div className="Log-left-logo">
          <img src={IsbcLogIn} alt="isbc login" />
        </div>
        <div className="Log-right-inputs">
          <div className="Login-inputs">
            <Twilio />
            <div className="TermsLogin">
              <p>By continuing, you agree to iscb</p>
              <Link to="/terms&conditions"> Terms of Usage</Link>
            </div>
            <div className="line-or">
              <h3>(or)</h3>
            </div>
            <div className="Ggle-container">
              <GoogleLoginBtn />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
